import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer style={{ background: "#1d1d1f" }}>
      <div className="section-wrap" style={{ paddingTop: "56px", paddingBottom: "36px" }}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "40px", marginBottom: "48px" }}>

          {/* Brand */}
          <div style={{ maxWidth: "280px" }}>
            <img src="/images/logo.png" alt="aInnovation" style={{ height: "48px", width: "auto", marginBottom: "14px" }} />
            <p style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.45)", lineHeight: 1.7 }}>
              L'IA locale, performante et privée — installée directement dans vos locaux.
            </p>
          </div>

          {/* Contact */}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {[
              { icon: <Mail size={13} />,   val: "info@ainnovation.ca"  },
              { icon: <Phone size={13} />,  val: "+1 (450) 735-1466"     },
              { icon: <MapPin size={13} />, val: "Québec, Canada"         },
            ].map((r, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.8125rem", color: "rgba(255,255,255,0.45)" }}>
                <span style={{ color: "#0071e3" }}>{r.icon}</span>
                {r.val}
              </div>
            ))}
          </div>

          {/* Links */}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {[
              { label: "Services",          href: "#solutions"   },
              { label: "Notre approche",    href: "#technologie" },
              { label: "Contact",           href: "#contact"     },
            ].map((l) => (
              <a key={l.label} href={l.href}
                 style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.45)", textDecoration: "none" }}
                 onMouseEnter={e => e.target.style.color = "rgba(255,255,255,0.85)"}
                 onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.45)"}>
                {l.label}
              </a>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: "24px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <p style={{ fontSize: "0.8125rem", color: "rgba(255,255,255,0.3)" }}>
            © {new Date().getFullYear()} aInnovation Inc. Tous droits réservés.
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#34c759" }} />
            <span style={{ fontSize: "0.8125rem", color: "rgba(255,255,255,0.3)" }}>
              100 % local · Conforme Loi 25
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
